import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import BrowserFrame from "./BrowserFrame";

const PROMPTS = [
  "Quanto manca alla soglia degli 85.000€?",
  "Quanto devo mettere da parte per le tasse quest'anno?",
  "Quali fatture sono da incassare?",
  "Qual è il mio netto disponibile ad oggi?",
];

// SEZIONE 2 — Olli protagonista (split layout, allineato al pattern delle Showcase)
export default function OlliSection() {
  return (
    <section className="olli-section" id="olli">
      <div className="container">
        <div className="showcase-grid">
          <Reveal className="olli-copy">
            <p className="section-label">Olli, il tuo assistente fiscale</p>
            <h2 className="showcase-title">
              Chiedi quello che vuoi. Olli risponde coi tuoi numeri.
            </h2>
            <p className="showcase-body">
              Tasse da pagare, ore lavorate, scadenze, netto disponibile — fai
              la domanda e Olli ti risponde subito, in italiano semplice. Niente
              gergo, niente attese.
            </p>

            <ul className="olli-prompts">
              {PROMPTS.map((p) => (
                <li key={p} className="olli-prompt">
                  <Sparkles
                    className="olli-prompt-icon"
                    size={16}
                    strokeWidth={1.5}
                    aria-hidden="true"
                  />
                  <span>“{p}”</span>
                </li>
              ))}
            </ul>

            <Link to="/accedi" className="btn btn-peach">
              Prova Olli
            </Link>
          </Reveal>

          <Reveal className="showcase-visual" delay={120}>
            <BrowserFrame
              src="/landing-assets/screenshots/olli-chat.png"
              alt="Conversazione con Olli, l'assistente AI di Forfy"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
